import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import api from "@/lib/api";
import { TID } from "@/lib/testIds";
import { toast } from "sonner";

const Footer = () => {
  const { settings } = useStore();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const cols = settings?.footer || [];
  const brand = settings?.brand || {};

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/newsletter", { email, source: "footer", consent }); toast.success("Welcome to NoirbyAmara."); setEmail(""); }
    catch { toast.error("Something went wrong. Please try again."); }
  };

  return (
    <footer className="bg-cocoa text-cream mt-24">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-12 pb-16 border-b border-white/10">
          <div>
            <p className="overline text-gold mb-4">Private Access</p>
            <h3 className="font-serif text-4xl md:text-5xl leading-none mb-5">Join our world.</h3>
            <p className="text-cream/70 text-sm max-w-md mb-6 leading-relaxed">Early access to new chapters, considered stories and quiet invitations. No noise.</p>
            <form onSubmit={submit} className="flex flex-col gap-3 max-w-md">
              <div className="flex border-b border-cream/30 focus-within:border-gold transition-colors">
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid={TID.newsletterEmail} placeholder="Your email"
                  className="bg-transparent flex-1 py-3 text-sm outline-none placeholder:text-cream/40" />
                <button type="submit" data-testid={TID.newsletterSubmit} className="text-[0.7rem] tracking-[0.2em] uppercase">Join</button>
              </div>
              <label className="flex items-start gap-2 text-[0.72rem] text-cream/50">
                <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" />
                I agree to receive marketing emails from NoirbyAmara.
              </label>
            </form>
          </div>
          <div className="grid grid-cols-2 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <p className="overline text-cream/50 mb-4">{c.title}</p>
                <ul className="space-y-2.5 text-sm text-cream/80">
                  {c.links.map((l) => <li key={l.href}><Link to={l.href} className="hover-underline">{l.label}</Link></li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-12 flex flex-col md:flex-row justify-between gap-8">
          <div>
            <p className="font-serif text-3xl tracking-[0.12em] mb-2">{brand.name || "NOIRBYAMARA"}</p>
            <p className="text-cream/60 text-sm">{brand.tagline}</p>
            <p className="text-cream/40 text-xs mt-4 max-w-xs">{brand.address}</p>
            <p className="text-cream/40 text-xs mt-1">{brand.positioning}</p>
          </div>
          <div className="flex gap-6 text-[0.72rem] tracking-[0.18em] uppercase text-cream/70 items-start">
            {[["Instagram", settings?.socials?.instagram], ["TikTok", settings?.socials?.tiktok], ["Pinterest", settings?.socials?.pinterest]]
              .filter(([, url]) => url && url.trim())
              .map(([label, url]) => {
                const href = /^https?:\/\//i.test(url.trim()) ? url.trim() : `https://${url.trim().replace(/^\/+/, "")}`;
                return (
                  <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                    data-testid={`footer-social-${label.toLowerCase()}`} className="hover-underline">{label}</a>
                );
              })}
          </div>
        </div>
        <p className="text-cream/30 text-xs mt-12">© {new Date().getFullYear()} NoirbyAmara. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
